/* eslint-disable camelcase */

export enum playerPrivacyStatusesEnum {
  none = 'none',
  partial = 'partial',
  full = 'full',
  selective = 'selective',
}

export enum tableTypesEnum {
  lastBets = 'last-bets',
  highRollers = 'high-rollers',
  luckyBets = 'lucky-bets',
}

export enum activeTablesTypes {
  standard = 'standard',
  highRollers = 'high_rollers',
  luckyBets = 'lucky_bets',
}

export { activeTablesTypes as ActiveTablesTypes }

export interface IGetSlotsLastWinsPayload {
  page: number
  page_size: number
  table_type: activeTablesTypes
}

export interface IConvertedSlotsLastWinsItem {
  roundId: string
  gameId: string
  userId: number
  username?: string
  balanceCurrency: string
  provider: string
  totalBetAmount: string
  multiplier: string
  totalWinAmount: string
  date: string
  isNickHidden: boolean
}

export interface IConvertedSlotsLastWinsList {
  page: number
  count: number
  wins: IConvertedSlotsLastWinsItem[] | []
}

export interface ISlotsLastWinsItemDTO {
  round_id: string
  game_id: string
  max_user_id: number
  username?: string
  balance_after_currency: string
  producer: string
  total_bet_amount: string
  multiplier: string
  total_win_amount: string
  max_date: string
  is_nick_hidden: boolean
}

export interface IPlayerPrivacySettingsDTO {
  player_nick_hide_mode: playerPrivacyStatusesEnum
  nick_hidden?: boolean
  active_tables: activeTablesTypes[]
}

export interface IConvertedPlayerPrivacySettings {
  hideMode: playerPrivacyStatusesEnum
  isNickHidden?: boolean
  activeTables: activeTablesTypes[]
}
